export default {
  cancel: 'Annulla',
  circle_config: 'Configurazione cerchio',
  confirm: 'Conferma',
  confirm_delete:
    'Sei sicuro di voler eliminare questa caratteristica? Questa operazione non può essere annullata.',
  create: 'Crea',
  delete_geometry: 'Elimina geometria',
  delete_vertex: 'Rimuovi vertice',
  document_upload_failed: 'Caricamento documento non riuscito.',
  draw_circle: 'Cerchio dal centro',
  draw_circle_2pt: 'Cerchio manuale',
  draw_dialog_begin_drawing: 'Inizia a disegnare - Clicca ovunque sulla mappa',
  draw_dialog_cancel_drawing: 'Annulla disegno - Tasto ESC',
  draw_dialog_remove_vertex:
    'Rimuovi ultimo vertice - Clicca con il tasto destro',
  draw_dialog_save: 'Salva - Doppio clic',
  draw_dialog_save_single: 'Salva - Clic singolo',
  draw_dialog_title: 'Istruzioni di disegno',
  draw_line: 'Linea',
  draw_point: 'Punto',
  draw_polygon: 'Poligono',
  draw_position: 'Posizione attuale',
  draw_rectangle: 'Rettangolo',
  edit_dialog_cancel_drawing:
    'Annulla disegno - Clicca sul pulsante di annullamento per annullare il disegno.',
  edit_dialog_modify_shape:
    'Modifica forma - Trascina un vertice per modificare la forma o aggiungi un nuovo vertice al poligono.',
  edit_dialog_remove_vertex:
    'Rimuovi vertice - Clicca su un vertice per rimuoverlo.',
  edit_dialog_save:
    'Salva - Clicca sul pulsante di salvataggio per salvare le tue modifiche.',
  edit_dialog_title: 'Istruzioni di modifica',
  filter_searchbox_placeholder: 'Cerca',
  icon_scaling_cluster: 'Scala icona cluster',
  icon_scaling_cluster_log: 'Scala logaritmica cluster',
  icon_scaling_field: 'Attiva/disattiva ridimensionamento icone campo',
  icon_scaling_label: 'Scala icona',
  icon_scaling_zoom_in: 'Scala ingrandimento',
  icon_scaling_zoom_out: 'Scala riduzione',
  identical_values_filter:
    'Questo campo contiene solo un valore distinto e non può essere filtrato.',
  image_upload_failed: 'Caricamento immagine non riuscito.',
  information: 'Informazioni',
  invalid_geometry: 'Geometria non valida',
  invalid_lat_lon:
    'Le coordinate fornite non rientrano nella località selezionata.',
  invalid_lat_long_range:
    "Coordinate non valide: I valori di latitudine e longitudine devono essere all'interno di intervalli validi.",
  layer_add_new_location: 'Aggiungi nuove località',
  layer_dataview_header: 'Visualizzazioni dati',
  layer_filter_clear_all: 'Cancella tutti i filtri',
  layer_filter_dropdown_select: 'Seleziona più',
  layer_filter_greater_than: 'Maggiore di',
  layer_filter_header: 'Filtro',
  layer_filter_less_than: 'Minore di',
  layer_filter_reset_all: 'Reimposta tutti i filtri',
  layer_filter_select: 'Seleziona filtro dalla lista',
  layer_filter_set_filter: 'Imposta filtro',
  layer_grid_legend_ratio:
    'Visualizza colore come rapporto rispetto alla dimensione',
  layer_group_hide_layers: 'Nascondi tutte le layer nel gruppo',
  layer_style_cluster: 'Località multiple',
  layer_style_display_hover: 'Abilita hover',
  layer_style_display_labels: 'Visualizza etichette',
  layer_style_header: 'Stile',
  layer_style_opacity: 'Cambia opacità layer:',
  layer_style_select_theme: 'Seleziona stile tematico',
  layer_style_switch_all: 'cambia tutto',
  layer_style_switch_caption:
    'Clicca sulle etichette per cambiare visibilità o',
  layer_visibility: 'Attiva/disattiva visibilità',
  layer_zoom_to_extent: "Zoom all'estensione layer filtrata",
  layers: 'Layer',
  link: 'Collegamento',
  loading: 'Caricamento',
  location_clear_all: 'Cancella località',
  location_close_without_save:
    'Chiudere la località senza salvare le modifiche?',
  location_delete: 'Elimina località',
  location_listview_full: 'La vista elenco per le località è piena.',
  location_remove: 'Rimuovi caratteristica dalla selezione',
  location_save: 'Salva modifiche nel cloud',
  location_save_changes: 'Vuoi salvare le modifiche a questa località?',
  location_zoom: 'Zoom sulla mappa per le caratteristiche',
  locations: 'Località',
  modify_geometry: 'Modifica geometria',
  no_data_filter: 'Questo campo non contiene dati e non può essere filtrato.',
  no_layers: 'Nessun layer accessibile nella località.',
  no_locales:
    'Il tuo account è stato verificato e approvato, ma non hai accesso a nessuna località. Questo è probabilmente dovuto al fatto che un amministratore non ti ha assegnato i ruoli richiesti. Contatta un amministratore per risolvere questo problema.',
  no_options_available: 'Nessuna opzione disponibile.',
  no_results: 'Nessun risultato per questa ricerca',
  ok: 'OK',
  pill_component_remove: 'Rimuovi',
  pin: 'Fissa',
  radius: 'Raggio',
  remove_document_confirm:
    'Sei sicuro di voler rimuovere questo documento? Questa operazione non può essere annullata.',
  remove_image_confirm:
    'Sei sicuro di voler rimuovere l’immagine? Questa operazione non può essere annullata.',
  remove_item_confirm: 'Rimuovi elemento?',
  remove_last_vertex: 'Rimuovi ultimo vertice',
  report: 'Rapporto',
  save: 'Salva',
  toolbar_admin: "Apri vista amministrativa dell'account",
  toolbar_current_location: 'Posizione attuale',
  toolbar_fullscreen: 'Mappa a schermo intero',
  toolbar_login: 'Accedi',
  toolbar_logout: 'Esci',
  toolbar_zoom_in: 'Ingrandisci',
  toolbar_zoom_out: 'Riduci',
  toolbar_zoom_to_area: "Zoom all'area",
  units: 'Unità',
  zoom_to: 'Zoom a',
};
